import styled from "styled-components";

export const DivFlex = styled.div`
    display: flex;
    width: 100%;
`;

interface IIndicatorListChildren{
    childrenLevel?: number;
}

export const DivAlignCenterWithOverflow = styled.div<IIndicatorListChildren>`
    display: flex;
    align-items: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    ${(props) => props.childrenLevel && `
        padding-left: ${props.childrenLevel * 0.5}rem;
    `}
`;

interface IOverflowSpanBold{
    clickHoverEffect?: boolean;
}

const OverflowSpanBold = styled.span<IOverflowSpanBold>`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-weight: bold;

    ${(props) => props.clickHoverEffect && `
        transition: 100ms ease;
        cursor: pointer;
        &:hover{
            text-decoration: underline;
        }
    `}
`;

export const OverflowSpan = styled.span`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;

interface IIndicatorsPanelHeader{
    currentPeriod?: boolean;
}

export const IndicatorsPanelHeader = styled.div<IIndicatorsPanelHeader>`
    width: 72px;
    min-width: 72px;
    max-width: 72px;
	display: flex;
	align-items: center;
	justify-content: center;

    user-select: none;

    margin: 0 4px;
	padding: 0;
    border: 0;
    box-shadow: none;

    ${(props) => props.currentPeriod && `
        font-weight: bold;
        box-shadow: 0 0 0 4px transparent;
    `}
`;

interface ICardIndicatorPanel{
    color: string;
    hasValue: boolean;
    notHover?: boolean;
    currentPeriod?: boolean;
    isDisabled?: boolean;
}

export const CardIndicatorPanel = styled.span<ICardIndicatorPanel>`
    width: 72px;
    min-width: 72px;
    max-width: 72px;
	display: flex;
	align-items: center;
	justify-content: center;

    position: relative;

	color: #FFF;
	background-color: var(--progress-background);

	margin: 0 4px;
	padding: 0;
    border: 0;
    box-shadow: none;

    user-select: none;

	border-radius: 4px;
    transition: 100ms ease;

    ${(props) => !props.notHover && `
        cursor: pointer;
        &:hover{
            filter: brightness(0.7);
        }
    `}

    >span{
        z-index: 1;
        font-size: 0.75rem;
    }

    >div.progress{
        position: absolute;
        left: 0;
        height: 100%;
        border-radius: 4px;
        background-color: ${(props) => props.color};
    }

    ${(props) => !props.hasValue && `
        opacity: 0.25;
        >div.progress{
            background-color: transparent;
        }
    `}

    ${(props) => props.currentPeriod && `
        box-shadow: 0 0 0 4px var(--yellow);
        font-weight: bold;
    `}

    ${(props) => props.isDisabled && `
        border: none;
        background: transparent;
        box-shadow: none;
        >div.progress{
            background: transparent;
        }
    `}
`;

export const ArrowLeft = styled.div`
    display: flex;
	align-items: center;
	position: absolute;
	left: -10px;
	z-index: 2;

    user-select: none;
    
    transition: 200ms ease;

    &:hover{
        transform: scale(1.5);
        opacity: 1;
    }
`;

export const ArrowRight = styled.div`
    display: flex;
	align-items: center;
	position: absolute;
	right: -10px;
	z-index: 2;

    user-select: none;

    transition: 200ms ease;

    &:hover{
        transform: scale(1.5);
        opacity: 1;
    }
`;

interface IDivValues{
    borderRight?: boolean;
}

export const DivValues = styled.div<IDivValues>`
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow-x: hidden; 
    overflow-y: hidden; 
    position: relative;

    transition: 200ms ease;

    .arrowLeft-indicators,
    .arrowRight-indicators{
        display: flex;
        opacity: 0.25;
    }

    &:hover{
        .arrowLeft-indicators,
        .arrowRight-indicators{
            display: flex;
            opacity: 0.5;
            cursor: pointer;
        }
    }

    @media(max-width: 599px){
        .arrowLeft-indicators,
        .arrowRight-indicators{
            display: flex;
            opacity: 0.75;
            cursor: pointer;
        }
    }

    border: none;
    ${(props) => props.borderRight && `
        border-right: 1px solid var(--border-color);
        @media(max-width: 960px){
            border-right: none;
        }
    `}
`;

export default OverflowSpanBold;
